import React, { useEffect, useRef, useState } from "react";
import {
    Alert,
    Button,
} from "@mui/material";

import CourseInfoWidget from "../components/widgets/CourseInfoWidget";
import SocialShareWidget from "../components/widgets/SocialShareWidget";
import Payment from "./Payment";

import {
    getUserNameByGId,
} from "../handler/LoginAndSingupHandler";

import packagePoster from "../Common/PackagePoster.js";
import UserLoaderBlankBackground from "src/Dashboard/UserLoaderBlankBackground";
import confetti from "canvas-confetti";

import {
    GetCourseList,
} from "src/handler/coursehandler";

import courseImage from "src/Common/CourseImage";

import {
    ClipLoader,
} from "react-spinners";

import CartIcon from "../Payment/CartIcon";
import CartModal from "./CartModal";


const Package = () => {

    /* =========================================================
       CONFIG
    ========================================================= */

    const discountOnPackage = 20;
    const discountOnCourses = 10;

    /* =========================================================
       STATE
    ========================================================= */

    const [template, setTemplate] = useState<
        "package" | "packageDetail" | "payment" | "cart"
    >("package");

    const [loader, setLoader] = useState(false);

    const [sponsorGrowniverseId, setSponsorGrowniverseId] =
        useState("");

    const [addNewSponsorGrowniverseId, setAddNewSponsorGrowniverseId] =
        useState("");

    const [couponCode, setCouponCode] =
        useState(false);

    const [inputCouponCode, setInputCouponCode] =
        useState("");

    const [showCouponCode, setShowCouponCode] =
        useState(false);

    const [invalidCouponCode, setInvalidCouponCode] =
        useState(false);

    const [userInformationId, setUserInformationId] =
        useState("");

    const [getShowPackages, setShowPackages] =
        useState(false);

    const [searchTerm, setSearchTerm] =
        useState("");

    const [showCart, setShowCart] =
        useState(false);

    const [packages, setPackages] =
        useState<any[]>([]);

    const [packageDetailData, setPackageDetailPage] =
        useState<any>({
            packageId: 0,
            packageName: "",
            packageDescription: "",
            packagePrice: 12000,
            discountedPrice: 8500,
        });

    const [coursesList, setCoursesList] =
        useState<any[]>([]);

    const [checkCountCourseList, setCheckoutCoursesList] =
        useState<any[]>([]);

    const [hasMore, setHasMore] =
        useState(true);

    /* =========================================================
       REFS
    ========================================================= */

    const runOnce = useRef(false);
    const runOnceForLoad = useRef(false);
    const listloader = useRef<HTMLDivElement>(null);
    const skip = useRef(0);

    const take = 100;


    /* =========================================================
       LOAD USER + PACKAGES
    ========================================================= */

    useEffect(() => {

        if (runOnce.current) return;

        try {

            const storedProfile =
                localStorage.getItem("userProfile");

            if (storedProfile) {

                const userProfile =
                    JSON.parse(storedProfile);

                if (userProfile?.status > 3) {
                    window.location.href = "/dashboard";
                    return;
                }

                setUserInformationId(
                    userProfile?.userInformationId || ""
                );

                setSponsorGrowniverseId(
                    userProfile?.sponsorGrowniverseId || ""
                );
            }

            const storedPackages =
                localStorage.getItem("packages");

            if (storedPackages) {

                const packagesData =
                    JSON.parse(storedPackages);

                if (Array.isArray(packagesData)) {
                    setPackages(packagesData);
                }
            }

        } catch (error) {

            console.error(
                "Unable to load package information:",
                error
            );

        }

        runOnce.current = true;

    }, []);


    /* =========================================================
       LOAD COURSES
    ========================================================= */

    const loadCourses = async () => {

        if (!hasMore) return;

        try {

            const response =
                await GetCourseList({
                    skip: skip.current,
                    take,
                });

            const newCourses =
                response?.data?.courses?.courseList || [];

            const totalRecords =
                response?.data?.courses?.totalRecords || 0;

            setCoursesList(newCourses);

            if (
                skip.current + take >=
                totalRecords
            ) {
                setHasMore(false);
            }

            skip.current += take;

        } catch (error) {

            console.error(
                "Unable to load courses:",
                error
            );

            setHasMore(false);
        }
    };


    useEffect(() => {

        if (runOnceForLoad.current) return;

        loadCourses();

        runOnceForLoad.current = true;

    }, []);


    /* =========================================================
       HELPERS
    ========================================================= */

    const discountCourses = (
        coursePrice: number,
        discount: number
    ) => {

        const discounted =
            coursePrice -
            coursePrice * (discount / 100);

        return Math.round(discounted);
    };


    const getPackagePoster = (
        packageId: number
    ) => {

        return packagePoster.find(
            (data: any) =>
                data.packageId === packageId
        )?.poster;
    };


    const getCoursePoster = (
        courseId: number
    ) => {

        return courseImage.find(
            (data: any) =>
                data.courseId === courseId
        )?.posterLink;
    };


    /* =========================================================
       PACKAGE DETAILS
    ========================================================= */

    const packageDetails = (
        pack: any
    ) => {

        if (!pack) return;

        setPackageDetailPage(pack);

        setTemplate("packageDetail");

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       COUPON
    ========================================================= */

    const onCouponCodeChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {

        setInvalidCouponCode(false);

        setInputCouponCode(
            event.target.value
        );
    };


    const getUserNameByGID = async () => {

        if (!inputCouponCode.trim()) {

            setInvalidCouponCode(true);

            return;
        }

        setLoader(true);

        try {

            if (
                inputCouponCode.trim() !==
                "R1999"
            ) {

                const response =
                    await getUserNameByGId(
                        inputCouponCode.trim(),
                        true
                    );

                if (response.success) {

                    setAddNewSponsorGrowniverseId(
                        response.data.userName
                    );

                    setCouponCode(true);

                    setShowCouponCode(false);

                    setInvalidCouponCode(false);

                    confetti({
                        particleCount: 150,
                        spread: 80,
                        origin: {
                            y: 0.6,
                        },
                        colors: [
                            "#00e5ff",
                            "#8b5cf6",
                            "#ffffff",
                            "#22c55e",
                        ],
                        shapes: [
                            "square",
                            "circle",
                        ],
                    });

                } else {

                    setAddNewSponsorGrowniverseId("");

                    setCouponCode(false);

                    setInvalidCouponCode(true);
                }

            } else {

                setAddNewSponsorGrowniverseId("");

                setCouponCode(false);

                setInvalidCouponCode(true);
            }

        } catch (error) {

            console.error(
                "Coupon validation error:",
                error
            );

            setInvalidCouponCode(true);

        } finally {

            setLoader(false);
        }
    };


    const removeCoupon = () => {

        setCouponCode(false);

        setAddNewSponsorGrowniverseId("");

        setInputCouponCode("");

        setInvalidCouponCode(false);
    };


    /* =========================================================
       FILTER COURSES
    ========================================================= */

    const filteredCourses =
        coursesList.filter(
            (course) =>
                course?.courseName
                    ?.toLowerCase()
                    .includes(
                        searchTerm.toLowerCase()
                    )
        );


    /* =========================================================
       CART
    ========================================================= */

    const isCourseInCart = (
        courseId: number
    ) => {

        return checkCountCourseList.some(
            (item) =>
                item.courseId === courseId
        );
    };


    const addToCart = (
        course: any
    ) => {

        if (isCourseInCart(course.courseId))
            return;

        setCheckoutCoursesList(
            (prev) => [
                ...prev,
                course,
            ]
        );
    };


    const removeFromCart = (
        courseId: number
    ) => {

        setCheckoutCoursesList(
            (prev) =>
                prev.filter(
                    (item) =>
                        item.courseId !==
                        courseId
                )
        );
    };


    /* =========================================================
       PACKAGE / COURSE SWITCH
    ========================================================= */

    const UpdateRecord = () => {

        setShowPackages(
            !getShowPackages
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       CLOSE / BACK
    ========================================================= */

    const goToPackages = () => {

        setTemplate("package");

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       RENDER
    ========================================================= */

    return (
        <>
            <div className="package-page">

                {/* =====================================================
                    GLOBAL BACKGROUND
                ===================================================== */}

                <div className="package-bg">

                    <div className="bg-grid" />

                    <div className="bg-glow bg-glow-cyan" />

                    <div className="bg-glow bg-glow-purple" />

                    <div className="bg-glow bg-glow-blue" />

                </div>


                {/* =====================================================
                    TOP SPACE FOR EXISTING HEADER
                    Prevents content from going behind fixed header.
                ===================================================== */}

                <div className="header-safe-space" />


                {/* =====================================================
                    FLOATING CART
                ===================================================== */}

                {template !== "payment" && (

                    <button
                        className={
                            template === "cart"
                                ? "floating-cart floating-close"
                                : "floating-cart"
                        }
                        onClick={() => {

                            if (
                                template ===
                                "cart"
                            ) {
                                setTemplate(
                                    "package"
                                );
                            } else {
                                setTemplate(
                                    "cart"
                                );
                            }

                        }}
                        aria-label="Shopping cart"
                    >

                        {template === "cart" ? (

                            <span className="close-icon">
                                ×
                            </span>

                        ) : (

                            <>
                                <CartIcon
                                    count={
                                        checkCountCourseList.length
                                    }
                                />
                            </>

                        )}

                        {template !== "cart" && (
                            <span className="cart-label">
                                CART
                            </span>
                        )}

                    </button>

                )}


                {/* =====================================================
                    CART
                ===================================================== */}

                {template === "cart" && (

                    <main className="content-wrapper">

                        <CartModal
                            items={
                                checkCountCourseList
                            }
                            isDiscount={
                                couponCode
                            }
                            AddNewSponsorGrowniverseId={
                                addNewSponsorGrowniverseId
                            }
                        />

                    </main>

                )}


                {/* =====================================================
                    MAIN STORE
                ===================================================== */}

                {template !== "cart" &&
                    template !== "payment" &&
                    template !== "packageDetail" && (

                        <main className="content-wrapper">

                            {/* =================================================
                                HERO
                            ================================================= */}

                            <section className="store-hero">

                                <div className="hero-content">

                                    <div className="eyebrow">
                                        <span className="eyebrow-dot" />
                                        GROWNIVERSE DIGITAL ACADEMY
                                    </div>

                                    <h1>

                                        Upgrade Your

                                        <span>
                                            Knowledge
                                        </span>

                                    </h1>

                                    <p>
                                        Explore premium courses
                                        and learning packages
                                        designed for your growth.
                                    </p>

                                </div>


                                <button
                                    className="hero-coupon"
                                    onClick={() =>
                                        setShowCouponCode(true)
                                    }
                                >

                                    <span>
                                        🎟
                                    </span>

                                    APPLY COUPON

                                </button>

                            </section>


                            {/* =================================================
                                SWITCH
                            ================================================= */}

                            <div className="view-switch-wrapper">

                                <div className="view-switch">

                                    <button
                                        className={
                                            !getShowPackages
                                                ? "switch-btn active"
                                                : "switch-btn"
                                        }
                                        onClick={() => {

                                            if (
                                                getShowPackages
                                            ) {
                                                UpdateRecord();
                                            }

                                        }}
                                    >

                                        <span>
                                            🎓
                                        </span>

                                        Courses

                                    </button>


                                    <button
                                        className={
                                            getShowPackages
                                                ? "switch-btn active"
                                                : "switch-btn"
                                        }
                                        onClick={() => {

                                            if (
                                                !getShowPackages
                                            ) {
                                                UpdateRecord();
                                            }

                                        }}
                                    >

                                        <span>
                                            ◈
                                        </span>

                                        Packages

                                    </button>

                                </div>

                            </div>


                            {/* =================================================
                                COUPON STATUS
                            ================================================= */}

                            {couponCode && (

                                <div className="coupon-status">

                                    <div>

                                        <span className="success-icon">
                                            ✓
                                        </span>

                                        <div>

                                            <strong>
                                                Coupon Applied
                                            </strong>

                                            <small>
                                                Special pricing unlocked
                                            </small>

                                        </div>

                                    </div>

                                    <button
                                        onClick={
                                            removeCoupon
                                        }
                                    >
                                        Remove Coupon
                                    </button>

                                </div>

                            )}


                            {/* =================================================
                                PACKAGES
                            ================================================= */}

                            {getShowPackages ? (

                                <section className="products-section">

                                    <div className="section-heading">

                                        <div>

                                            <span>
                                                PREMIUM COLLECTION
                                            </span>

                                            <h2>
                                                Learning Packages
                                            </h2>

                                        </div>

                                        <p>
                                            Complete learning
                                            experiences built
                                            for serious growth.
                                        </p>

                                    </div>


                                    <div className="package-grid">

                                        {packages.length === 0 ? (

                                            <div className="empty-state">

                                                <div>
                                                    ◇
                                                </div>

                                                <h3>
                                                    Packages Coming Soon
                                                </h3>

                                                <p>
                                                    New learning
                                                    experiences are
                                                    being prepared.
                                                </p>

                                            </div>

                                        ) : (

                                            packages.map(
                                                (
                                                    pack,
                                                    index
                                                ) => (

                                                    <article
                                                        className="product-card package-card"
                                                        key={
                                                            pack.packageId ||
                                                            index
                                                        }
                                                    >

                                                        <div className="product-image">

                                                            <img
                                                                src={
                                                                    getPackagePoster(
                                                                        pack.packageId
                                                                    )
                                                                }
                                                                alt={
                                                                    pack.packageName
                                                                }
                                                            />

                                                            <span className="product-badge">
                                                                PACKAGE
                                                            </span>

                                                        </div>


                                                        <div className="product-body">

                                                            <h3>
                                                                {
                                                                    pack.packageName
                                                                }
                                                            </h3>


                                                            <div className="price-panel">

                                                                {!couponCode ? (

                                                                    <>
                                                                        <div className="current-price">
                                                                            ₹
                                                                            {
                                                                                pack.discountedPrice
                                                                            }
                                                                        </div>

                                                                        <div className="old-price">
                                                                            MRP ₹
                                                                            {
                                                                                pack.packagePrice
                                                                            }
                                                                        </div>
                                                                    </>

                                                                ) : (

                                                                    <>

                                                                        <div className="deal-label">
                                                                            SPECIAL DEAL
                                                                        </div>

                                                                        <div className="current-price">
                                                                            ₹
                                                                            {
                                                                                discountCourses(
                                                                                    pack.discountedPrice,
                                                                                    discountOnPackage
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div className="price-row">

                                                                            <span>
                                                                                Previous ₹
                                                                                {
                                                                                    pack.discountedPrice
                                                                                }
                                                                            </span>

                                                                            <span>
                                                                                Save {
                                                                                    discountOnPackage
                                                                                }%
                                                                            </span>

                                                                        </div>

                                                                    </>

                                                                )}

                                                            </div>


                                                            <button
                                                                className="primary-action"
                                                                onClick={() =>
                                                                    packageDetails(
                                                                        pack
                                                                    )
                                                                }
                                                            >

                                                                EXPLORE PACKAGE

                                                                <span>
                                                                    →
                                                                </span>

                                                            </button>

                                                        </div>

                                                    </article>

                                                )
                                            )

                                        )}

                                    </div>

                                </section>

                            ) : (

                                /* =================================================
                                   COURSES
                                ================================================= */

                                <section className="products-section">

                                    <div className="section-heading">

                                        <div>

                                            <span>
                                                LEARNING LIBRARY
                                            </span>

                                            <h2>
                                                Explore Courses
                                            </h2>

                                        </div>

                                        <p>
                                            Choose individual
                                            courses and build
                                            your own learning path.
                                        </p>

                                    </div>


                                    {/* SEARCH */}

                                    <div className="course-search">

                                        <span>
                                            ⌕
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Search courses..."
                                            value={
                                                searchTerm
                                            }
                                            onChange={
                                                (e) =>
                                                    setSearchTerm(
                                                        e.target.value
                                                    )
                                            }
                                        />

                                        {searchTerm && (

                                            <button
                                                onClick={() =>
                                                    setSearchTerm(
                                                        ""
                                                    )
                                                }
                                            >
                                                ×
                                            </button>

                                        )}

                                    </div>


                                    <div className="course-grid">

                                        {filteredCourses.length ===
                                        0 ? (

                                            <div className="empty-state">

                                                <div>
                                                    ⌕
                                                </div>

                                                <h3>
                                                    No Courses Found
                                                </h3>

                                                <p>
                                                    Try another
                                                    search term.
                                                </p>

                                            </div>

                                        ) : (

                                            filteredCourses.map(
                                                (
                                                    course
                                                ) => (

                                                    <article
                                                        className="product-card course-card"
                                                        key={
                                                            course.CourseId ||
                                                            course.courseId
                                                        }
                                                    >

                                                        <div className="product-image">

                                                            <img
                                                                src={
                                                                    getCoursePoster(
                                                                        course.courseId
                                                                    )
                                                                }
                                                                alt={
                                                                    course.courseName
                                                                }
                                                            />

                                                            <span className="product-badge">
                                                                COURSE
                                                            </span>

                                                        </div>


                                                        <div className="product-body">

                                                            <h3>
                                                                {
                                                                    course.courseName
                                                                }
                                                            </h3>


                                                            <p className="course-description">

                                                                {
                                                                    course.courseDescription
                                                                }

                                                            </p>


                                                            <div className="price-panel">

                                                                {!couponCode ? (

                                                                    <div className="current-price">
                                                                        ₹
                                                                        {
                                                                            course.coursePrice
                                                                        }
                                                                    </div>

                                                                ) : (

                                                                    <>

                                                                        <div className="deal-label">
                                                                            SPECIAL DEAL
                                                                        </div>

                                                                        <div className="current-price">
                                                                            ₹
                                                                            {
                                                                                discountCourses(
                                                                                    course.coursePrice,
                                                                                    discountOnCourses
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div className="old-price">
                                                                            ₹
                                                                            {
                                                                                course.coursePrice
                                                                            }
                                                                        </div>

                                                                    </>

                                                                )}

                                                            </div>


                                                            {isCourseInCart(
                                                                course.courseId
                                                            ) ? (

                                                                <button
                                                                    className="cart-action remove"
                                                                    onClick={() =>
                                                                        removeFromCart(
                                                                            course.courseId
                                                                        )
                                                                    }
                                                                >

                                                                    <span>
                                                                        ✓
                                                                    </span>

                                                                    REMOVE FROM CART

                                                                </button>

                                                            ) : (

                                                                <button
                                                                    className="cart-action add"
                                                                    onClick={() =>
                                                                        addToCart(
                                                                            course
                                                                        )
                                                                    }
                                                                >

                                                                    <span>
                                                                        +
                                                                    </span>

                                                                    ADD TO CART

                                                                </button>

                                                            )}

                                                        </div>

                                                    </article>

                                                )
                                            )

                                        )}

                                    </div>


                                    {hasMore && (

                                        <div
                                            ref={
                                                listloader
                                            }
                                            className="course-loader"
                                        >

                                            <ClipLoader
                                                color="#00e5ff"
                                                size={35}
                                            />

                                        </div>

                                    )}

                                </section>

                            )}

                        </main>

                    )}


                {/* =====================================================
                    PACKAGE DETAIL
                ===================================================== */}

                {template ===
                    "packageDetail" && (

                        <main className="content-wrapper">

                            <section className="detail-page">

                                <button
                                    className="back-button"
                                    onClick={
                                        goToPackages
                                    }
                                >

                                    ←

                                    <span>
                                        Back
                                    </span>

                                </button>


                                <div className="detail-layout">

                                    <div className="detail-main">

                                        <div className="detail-image">

                                            <img
                                                src={
                                                    getPackagePoster(
                                                        packageDetailData.packageId
                                                    )
                                                }
                                                alt={
                                                    packageDetailData.packageName
                                                }
                                            />

                                        </div>


                                        <div className="detail-heading">

                                            <span>
                                                PREMIUM PACKAGE
                                            </span>

                                            <h1>
                                                {
                                                    packageDetailData.packageName
                                                }
                                            </h1>

                                        </div>


                                        <div className="detail-info">

                                            <CourseInfoWidget
                                                packageId={
                                                    packageDetailData.packageId
                                                }
                                            />

                                        </div>


                                        <div className="share-section">

                                            <SocialShareWidget />

                                        </div>

                                    </div>


                                    <aside className="purchase-panel">

                                        <div className="purchase-label">
                                            PACKAGE ACCESS
                                        </div>


                                        {!couponCode ? (

                                            <>

                                                <div className="purchase-price">
                                                    ₹
                                                    {
                                                        packageDetailData.discountedPrice
                                                    }
                                                </div>

                                                <div className="purchase-old-price">
                                                    MRP ₹
                                                    {
                                                        packageDetailData.packagePrice
                                                    }
                                                </div>

                                            </>

                                        ) : (

                                            <>

                                                <div className="purchase-deal">
                                                    COUPON PRICE
                                                </div>

                                                <div className="purchase-price">
                                                    ₹
                                                    {
                                                        discountCourses(
                                                            packageDetailData.discountedPrice,
                                                            discountOnPackage
                                                        )
                                                    }
                                                </div>

                                                <div className="purchase-old-price">
                                                    ₹
                                                    {
                                                        packageDetailData.discountedPrice
                                                    }
                                                </div>

                                            </>

                                        )}


                                        <div className="purchase-divider" />


                                        <button
                                            className="purchase-button"
                                            onClick={() =>
                                                setTemplate(
                                                    "payment"
                                                )
                                            }
                                        >

                                            GET THIS PACKAGE

                                            <span>
                                                →
                                            </span>

                                        </button>


                                        <div className="secure-note">

                                            <span>
                                                ✓
                                            </span>

                                            Secure learning
                                            access

                                        </div>

                                    </aside>

                                </div>

                            </section>

                        </main>

                    )}


                {/* =====================================================
                    PAYMENT
                ===================================================== */}

                {template ===
                    "payment" && (

                        <main className="payment-page">

                            <button
                                className="back-button payment-back"
                                onClick={() =>
                                    setTemplate(
                                        "packageDetail"
                                    )
                                }
                            >

                                ←

                                <span>
                                    Back to package
                                </span>

                            </button>


                            <div className="payment-wrapper">

                                <Payment
                                    packageId={
                                        packageDetailData.packageId
                                    }
                                    packageName={
                                        packageDetailData.packageName
                                    }
                                    price={
                                        couponCode
                                            ? discountCourses(
                                                packageDetailData.discountedPrice,
                                                discountOnPackage
                                            )
                                            : packageDetailData.discountedPrice
                                    }
                                    IsUpgrade={false}
                                    CouponCode={
                                        couponCode
                                    }
                                    AddNewSponsorGrowniverseId={
                                        addNewSponsorGrowniverseId
                                    }
                                />

                            </div>

                        </main>

                    )}


                {/* =====================================================
                    COUPON MODAL
                ===================================================== */}

                {showCouponCode && (

                    <div
                        className="coupon-overlay"
                        onMouseDown={(e) => {

                            if (
                                e.target ===
                                e.currentTarget
                            ) {
                                setShowCouponCode(
                                    false
                                );
                            }

                        }}
                    >

                        {loader ? (

                            <UserLoaderBlankBackground />

                        ) : (

                            <div className="coupon-modal">

                                <button
                                    className="coupon-close"
                                    onClick={() =>
                                        setShowCouponCode(
                                            false
                                        )
                                    }
                                >
                                    ×
                                </button>


                                <div className="coupon-icon">
                                    🎟
                                </div>


                                <div className="coupon-title">

                                    <span>
                                        SPECIAL OFFER
                                    </span>

                                    <h2>
                                        Apply Coupon
                                    </h2>

                                    <p>
                                        Enter your sponsor
                                        code to unlock
                                        special pricing.
                                    </p>

                                </div>


                                {!couponCode ? (

                                    <input
                                        className="coupon-input"
                                        type="text"
                                        placeholder="Enter coupon code"
                                        value={
                                            inputCouponCode
                                        }
                                        onChange={
                                            onCouponCodeChange
                                        }
                                        autoFocus
                                    />

                                ) : (

                                    <div className="coupon-applied-box">

                                        <span>
                                            ✓
                                        </span>

                                        Coupon applied
                                        successfully

                                    </div>

                                )}


                                {invalidCouponCode && (

                                    <Alert
                                        severity="error"
                                        sx={{
                                            width:
                                                "100%",
                                            mb: 2,
                                        }}
                                    >
                                        Invalid Coupon Code
                                    </Alert>

                                )}


                                <div className="coupon-actions">

                                    {!couponCode ? (

                                        <button
                                            className="coupon-apply"
                                            onClick={
                                                getUserNameByGID
                                            }
                                        >
                                            APPLY COUPON
                                        </button>

                                    ) : (

                                        <button
                                            className="coupon-remove"
                                            onClick={
                                                removeCoupon
                                            }
                                        >
                                            REMOVE COUPON
                                        </button>

                                    )}


                                    <button
                                        className="coupon-cancel"
                                        onClick={() =>
                                            setShowCouponCode(
                                                false
                                            )
                                        }
                                    >
                                        CANCEL
                                    </button>

                                </div>

                            </div>

                        )}

                    </div>

                )}

            </div>


            {/* =========================================================
                ALL STYLES IN SAME FILE
            ========================================================= */}

            <style>{`

                /* =====================================================
                   ROOT
                ===================================================== */

                .package-page {
                    --cyan: #00e5ff;
                    --cyan-soft: rgba(0,229,255,.12);
                    --purple: #8b5cf6;
                    --blue: #3b82f6;
                    --green: #22c55e;
                    --red: #ef4444;

                    position: relative;
                    min-height: 100vh;

                    color: #ffffff;

                    background:
                        radial-gradient(
                            circle at 15% 20%,
                            rgba(0,229,255,.10),
                            transparent 30%
                        ),
                        radial-gradient(
                            circle at 85% 60%,
                            rgba(139,92,246,.10),
                            transparent 32%
                        ),
                        #03070d;

                    overflow-x: hidden;

                    font-family:
                        Inter,
                        system-ui,
                        -apple-system,
                        BlinkMacSystemFont,
                        "Segoe UI",
                        sans-serif;
                }


                /* =====================================================
                   HEADER SAFE SPACE
                   Prevents fixed site header from covering content.
                ===================================================== */

                .header-safe-space {
                    height: clamp(
                        110px,
                        11vw,
                        165px
                    );
                }


                /* =====================================================
                   BACKGROUND
                ===================================================== */

                .package-bg {
                    position: fixed;
                    inset: 0;

                    pointer-events: none;

                    z-index: 0;

                    overflow: hidden;
                }


                .bg-grid {
                    position: absolute;
                    inset: 0;

                    opacity: .055;

                    background-image:
                        linear-gradient(
                            rgba(255,255,255,.15) 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            90deg,
                            rgba(255,255,255,.15) 1px,
                            transparent 1px
                        );

                    background-size:
                        45px 45px;
                }


                .bg-glow {
                    position: absolute;

                    width: 450px;
                    height: 450px;

                    border-radius: 50%;

                    filter: blur(120px);

                    opacity: .15;
                }


                .bg-glow-cyan {
                    left: -250px;
                    top: 150px;

                    background: var(--cyan);
                }


                .bg-glow-purple {
                    right: -250px;
                    top: 550px;

                    background: var(--purple);
                }


                .bg-glow-blue {
                    left: 40%;
                    bottom: -300px;

                    background: var(--blue);
                }


                /* =====================================================
                   CONTENT
                ===================================================== */

                .content-wrapper {
                    position: relative;

                    z-index: 2;

                    width: min(
                        1560px,
                        calc(100% - 40px)
                    );

                    margin: 0 auto;

                    padding-bottom: 100px;
                }


                /* =====================================================
                   HERO
                ===================================================== */

                .store-hero {
                    position: relative;

                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    min-height: 300px;

                    padding:
                        55px 55px;

                    margin-bottom: 38px;

                    border:
                        1px solid
                        rgba(0,229,255,.20);

                    border-radius: 0 0 26px 26px;

                    overflow: hidden;

                    background:
                        linear-gradient(
                            120deg,
                            rgba(0,229,255,.08),
                            rgba(5,10,20,.85) 35%,
                            rgba(5,7,18,.92)
                        );

                    box-shadow:
                        0 30px 90px
                        rgba(0,0,0,.45);
                }


                .store-hero::before {
                    content: "";

                    position: absolute;

                    left: 0;
                    top: 0;
                    bottom: 0;

                    width: 3px;

                    background:
                        linear-gradient(
                            transparent,
                            var(--cyan),
                            var(--purple),
                            transparent
                        );

                    box-shadow:
                        0 0 25px
                        var(--cyan);
                }


                .store-hero::after {
                    content: "";

                    position: absolute;

                    inset: 0;

                    pointer-events: none;

                    background:
                        linear-gradient(
                            90deg,
                            transparent 0%,
                            rgba(255,255,255,.035) 50%,
                            transparent 100%
                        );

                    opacity: .5;
                }


                .hero-content {
                    position: relative;

                    z-index: 2;

                    max-width: 850px;
                }


                .eyebrow {
                    display: flex;

                    align-items: center;

                    gap: 10px;

                    margin-bottom: 22px;

                    color: var(--cyan);

                    font-size: 13px;

                    font-weight: 800;

                    letter-spacing: 2px;
                }


                .eyebrow-dot {
                    width: 9px;
                    height: 9px;

                    border-radius: 50%;

                    background: var(--cyan);

                    box-shadow:
                        0 0 15px
                        var(--cyan);
                }


                .store-hero h1 {
                    margin: 0;

                    color: #ffffff;

                    font-size:
                        clamp(
                            42px,
                            5.5vw,
                            82px
                        );

                    line-height: .95;

                    font-weight: 800;

                    letter-spacing: -4px;
                }


                .store-hero h1 span {
                    display: block;

                    color: var(--cyan);

                    text-shadow:
                        0 0 30px
                        rgba(0,229,255,.25);
                }


                .store-hero p {
                    margin:
                        25px 0 0;

                    max-width: 700px;

                    color: #91a1b5;

                    font-size: 17px;

                    line-height: 1.7;
                }


                .hero-coupon {
                    position: relative;

                    z-index: 3;

                    display: flex;

                    align-items: center;

                    gap: 12px;

                    padding:
                        18px 28px;

                    border:
                        1px solid
                        rgba(139,92,246,.6);

                    border-radius: 15px;

                    background:
                        rgba(20,12,45,.65);

                    color: #ffffff;

                    font-size: 14px;

                    font-weight: 800;

                    letter-spacing: .5px;

                    cursor: pointer;

                    transition:
                        .25s ease;

                    white-space: nowrap;
                }


                .hero-coupon span {
                    color: #a78bfa;

                    font-size: 20px;
                }


                .hero-coupon:hover {
                    transform:
                        translateY(-3px);

                    border-color:
                        var(--purple);

                    box-shadow:
                        0 15px 35px
                        rgba(139,92,246,.20);
                }


                /* =====================================================
                   VIEW SWITCH
                ===================================================== */

                .view-switch-wrapper {
                    display: flex;

                    justify-content: center;

                    margin:
                        0 0 38px;
                }


                .view-switch {
                    display: flex;

                    padding: 5px;

                    border:
                        1px solid
                        rgba(255,255,255,.10);

                    border-radius: 18px;

                    background:
                        rgba(10,14,23,.75);

                    box-shadow:
                        0 15px 40px
                        rgba(0,0,0,.30);
                }


                .switch-btn {
                    min-width: 160px;

                    padding:
                        16px 30px;

                    border: none;

                    border-radius: 13px;

                    background:
                        transparent;

                    color: #78879a;

                    font-size: 14px;

                    font-weight: 800;

                    cursor: pointer;

                    transition: .25s ease;
                }


                .switch-btn span {
                    margin-right: 8px;
                }


                .switch-btn.active {
                    color: #001014;

                    background:
                        var(--cyan);

                    box-shadow:
                        0 0 30px
                        rgba(0,229,255,.22);
                }


                /* =====================================================
                   COUPON STATUS
                ===================================================== */

                .coupon-status {
                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    gap: 20px;

                    margin-bottom: 30px;

                    padding:
                        15px 18px;

                    border:
                        1px solid
                        rgba(34,197,94,.25);

                    border-radius: 15px;

                    background:
                        rgba(34,197,94,.07);
                }


                .coupon-status > div {
                    display: flex;

                    align-items: center;

                    gap: 12px;
                }


                .success-icon {
                    display: flex;

                    align-items: center;

                    justify-content: center;

                    width: 36px;
                    height: 36px;

                    border-radius: 50%;

                    color: #06100a;

                    background:
                        var(--green);

                    font-weight: 900;
                }


                .coupon-status strong,
                .coupon-status small {
                    display: block;
                }


                .coupon-status strong {
                    color: #ffffff;
                }


                .coupon-status small {
                    margin-top: 3px;

                    color: #82a28d;
                }


                .coupon-status button {
                    border: none;

                    background: transparent;

                    color: #ff7373;

                    font-weight: 700;

                    cursor: pointer;
                }


                /* =====================================================
                   SECTION
                ===================================================== */

                .products-section {
                    margin-top: 20px;
                }


                .section-heading {
                    display: flex;

                    justify-content: space-between;

                    align-items: end;

                    gap: 30px;

                    margin-bottom: 30px;
                }


                .section-heading span {
                    color: var(--cyan);

                    font-size: 11px;

                    font-weight: 800;

                    letter-spacing: 2px;
                }


                .section-heading h2 {
                    margin:
                        8px 0 0;

                    color: #ffffff;

                    font-size:
                        clamp(28px,4vw,42px);

                    font-weight: 800;
                }


                .section-heading p {
                    max-width: 430px;

                    margin: 0;

                    color: #748397;

                    line-height: 1.6;

                    text-align: right;
                }


                /* =====================================================
                   PRODUCT GRID
                ===================================================== */

                .package-grid,
                .course-grid {
                    display: grid;

                    grid-template-columns:
                        repeat(
                            3,
                            minmax(0,1fr)
                        );

                    gap: 24px;
                }


                .product-card {
                    position: relative;

                    overflow: hidden;

                    border:
                        1px solid
                        rgba(255,255,255,.09);

                    border-radius: 22px;

                    background:
                        linear-gradient(
                            145deg,
                            rgba(18,25,37,.95),
                            rgba(6,10,17,.98)
                        );

                    box-shadow:
                        0 20px 55px
                        rgba(0,0,0,.35);

                    transition:
                        transform .3s ease,
                        border-color .3s ease,
                        box-shadow .3s ease;
                }


                .product-card:hover {
                    transform:
                        translateY(-8px);

                    border-color:
                        rgba(0,229,255,.35);

                    box-shadow:
                        0 30px 70px
                        rgba(0,0,0,.45),
                        0 0 35px
                        rgba(0,229,255,.06);
                }


                .product-image {
                    position: relative;

                    height: 260px;

                    overflow: hidden;

                    background:
                        #0b1018;
                }


                .product-image::after {
                    content: "";

                    position: absolute;

                    inset: 0;

                    background:
                        linear-gradient(
                            transparent 45%,
                            rgba(0,0,0,.7)
                        );
                }


                .product-image img {
                    width: 100%;
                    height: 100%;

                    display: block;

                    object-fit: cover;

                    transition:
                        transform .5s ease;
                }


                .product-card:hover
                .product-image img {
                    transform:
                        scale(1.06);
                }


                .product-badge {
                    position: absolute;

                    top: 16px;
                    left: 16px;

                    z-index: 2;

                    padding:
                        9px 13px;

                    border:
                        1px solid
                        rgba(0,229,255,.4);

                    border-radius: 9px;

                    background:
                        rgba(3,9,16,.85);

                    color:
                        var(--cyan);

                    font-size: 10px;

                    font-weight: 900;

                    letter-spacing: 1.5px;

                    backdrop-filter:
                        blur(10px);
                }


                .product-body {
                    padding: 22px;
                }


                .product-body h3 {
                    min-height: 52px;

                    margin:
                        0 0 15px;

                    color: #ffffff;

                    font-size: 21px;

                    line-height: 1.25;

                    font-weight: 750;
                }


                .course-description {
                    height: 66px;

                    overflow: hidden;

                    margin:
                        0 0 15px;

                    color: #7f8da0;

                    font-size: 13px;

                    line-height: 1.65;
                }


                /* =====================================================
                   PRICE
                ===================================================== */

                .price-panel {
                    margin-bottom: 18px;

                    padding:
                        15px;

                    border:
                        1px solid
                        rgba(255,255,255,.06);

                    border-radius: 14px;

                    background:
                        rgba(255,255,255,.025);
                }


                .current-price {
                    color: #ffffff;

                    font-size: 28px;

                    font-weight: 850;
                }


                .current-price::first-letter {
                    color: var(--cyan);
                }


                .old-price {
                    margin-top: 4px;

                    color: #667486;

                    font-size: 13px;

                    text-decoration:
                        line-through;
                }


                .deal-label {
                    margin-bottom: 5px;

                    color:
                        var(--green);

                    font-size: 10px;

                    font-weight: 900;

                    letter-spacing: 1.5px;
                }


                .price-row {
                    display: flex;

                    justify-content: space-between;

                    gap: 10px;

                    margin-top: 4px;

                    color: #728096;

                    font-size: 11px;
                }


                /* =====================================================
                   ACTION BUTTONS
                ===================================================== */

                .primary-action,
                .cart-action,
                .purchase-button {
                    width: 100%;

                    display: flex;

                    align-items: center;

                    justify-content: space-between;

                    gap: 10px;

                    border: none;

                    border-radius: 13px;

                    padding:
                        15px 18px;

                    cursor: pointer;

                    font-size: 13px;

                    font-weight: 850;

                    transition: .25s ease;
                }


                .primary-action {
                    color: #001014;

                    background:
                        var(--cyan);
                }


                .primary-action:hover {
                    box-shadow:
                        0 0 25px
                        rgba(0,229,255,.25);
                }


                .cart-action.add {
                    justify-content: center;

                    color: #001014;

                    background:
                        var(--cyan);
                }


                .cart-action.remove {
                    justify-content: center;

                    color: #ffffff;

                    background:
                        rgba(239,68,68,.12);

                    border:
                        1px solid
                        rgba(239,68,68,.35);
                }


                .cart-action:hover {
                    transform:
                        translateY(-2px);
                }


                /* =====================================================
                   SEARCH
                ===================================================== */

                .course-search {
                    display: flex;

                    align-items: center;

                    gap: 12px;

                    margin-bottom: 30px;

                    padding:
                        0 18px;

                    height: 58px;

                    border:
                        1px solid
                        rgba(255,255,255,.10);

                    border-radius: 15px;

                    background:
                        rgba(10,15,24,.85);

                    box-shadow:
                        0 15px 40px
                        rgba(0,0,0,.25);
                }


                .course-search > span {
                    color: var(--cyan);

                    font-size: 25px;
                }


                .course-search input {
                    flex: 1;

                    min-width: 0;

                    border: none;

                    outline: none;

                    background:
                        transparent;

                    color: #ffffff;

                    font-size: 14px;
                }


                .course-search input::placeholder {
                    color: #586679;
                }


                .course-search button {
                    border: none;

                    background: transparent;

                    color: #748397;

                    font-size: 25px;

                    cursor: pointer;
                }


                /* =====================================================
                   EMPTY
                ===================================================== */

                .empty-state {
                    grid-column:
                        1 / -1;

                    padding:
                        70px 20px;

                    text-align: center;

                    border:
                        1px dashed
                        rgba(255,255,255,.12);

                    border-radius: 20px;

                    background:
                        rgba(255,255,255,.02);
                }


                .empty-state > div {
                    margin-bottom: 10px;

                    color: var(--cyan);

                    font-size: 42px;
                }


                .empty-state h3 {
                    margin: 0 0 8px;

                    color: #ffffff;
                }


                .empty-state p {
                    margin: 0;

                    color: #6d7a8b;
                }


                .course-loader {
                    display: flex;

                    align-items: center;

                    justify-content: center;

                    min-height: 100px;
                }


                /* =====================================================
                   FLOATING CART
                ===================================================== */

                .floating-cart {
                    position: fixed;

                    right: 25px;

                    bottom: 25px;

                    z-index: 900;

                    width: 72px;
                    height: 72px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border:
                        1px solid
                        rgba(0,229,255,.35);

                    border-radius: 50%;

                    background:
                        rgba(5,11,19,.94);

                    color: #ffffff;

                    box-shadow:
                        0 12px 35px
                        rgba(0,0,0,.5),
                        0 0 25px
                        rgba(0,229,255,.08);

                    cursor: pointer;

                    transition: .25s ease;

                    backdrop-filter:
                        blur(15px);
                }


                .floating-cart:hover {
                    transform:
                        translateY(-5px)
                        scale(1.04);

                    border-color:
                        var(--cyan);

                    box-shadow:
                        0 18px 45px
                        rgba(0,0,0,.55),
                        0 0 30px
                        rgba(0,229,255,.15);
                }


                .floating-close {
                    background:
                        rgba(70,15,25,.95);

                    border-color:
                        rgba(239,68,68,.4);
                }


                .close-icon {
                    color: #ff7272;

                    font-size: 38px;

                    line-height: 1;
                }


                .cart-label {
                    position: absolute;

                    bottom: -20px;

                    color: #667486;

                    font-size: 9px;

                    font-weight: 900;

                    letter-spacing: 1px;
                }


                /* =====================================================
                   DETAIL PAGE
                ===================================================== */

                .detail-page {
                    padding-bottom: 80px;
                }


                .back-button {
                    display: inline-flex;

                    align-items: center;

                    gap: 10px;

                    margin-bottom: 25px;

                    padding:
                        11px 17px;

                    border:
                        1px solid
                        rgba(255,255,255,.10);

                    border-radius: 12px;

                    background:
                        rgba(255,255,255,.04);

                    color: #ffffff;

                    cursor: pointer;

                    font-weight: 700;

                    transition: .25s ease;
                }


                .back-button:hover {
                    border-color:
                        var(--cyan);

                    color:
                        var(--cyan);
                }


                .detail-layout {
                    display: grid;

                    grid-template-columns:
                        minmax(0,1fr)
                        380px;

                    gap: 30px;

                    align-items: start;
                }


                .detail-main {
                    min-width: 0;
                }


                .detail-image {
                    height: 470px;

                    overflow: hidden;

                    border-radius: 24px;

                    border:
                        1px solid
                        rgba(0,229,255,.18);

                    background:
                        #0b1018;

                    box-shadow:
                        0 30px 70px
                        rgba(0,0,0,.45);
                }


                .detail-image img {
                    width: 100%;
                    height: 100%;

                    object-fit: cover;
                }


                .detail-heading {
                    margin:
                        30px 0;
                }


                .detail-heading span {
                    color: var(--cyan);

                    font-size: 11px;

                    font-weight: 900;

                    letter-spacing: 2px;
                }


                .detail-heading h1 {
                    margin:
                        10px 0 0;

                    color: #ffffff;

                    font-size:
                        clamp(30px,5vw,52px);

                    line-height: 1.1;
                }


                .detail-info {
                    padding:
                        25px;

                    border:
                        1px solid
                        rgba(255,255,255,.08);

                    border-radius: 20px;

                    background:
                        rgba(10,15,24,.75);
                }


                .share-section {
                    margin-top: 25px;

                    padding: 20px;

                    border-radius: 20px;

                    background:
                        rgba(255,255,255,.025);
                }


                /* =====================================================
                   PURCHASE
                ===================================================== */

                .purchase-panel {
                    position: sticky;

                    top: 180px;

                    padding: 28px;

                    border:
                        1px solid
                        rgba(0,229,255,.18);

                    border-radius: 22px;

                    background:
                        linear-gradient(
                            145deg,
                            rgba(12,20,31,.96),
                            rgba(5,9,16,.98)
                        );

                    box-shadow:
                        0 25px 70px
                        rgba(0,0,0,.45);
                }


                .purchase-label {
                    color: var(--cyan);

                    font-size: 11px;

                    font-weight: 900;

                    letter-spacing: 2px;
                }


                .purchase-price {
                    margin-top: 15px;

                    color: #ffffff;

                    font-size: 48px;

                    font-weight: 900;
                }


                .purchase-old-price {
                    color: #697688;

                    font-size: 14px;

                    text-decoration:
                        line-through;
                }


                .purchase-deal {
                    margin-top: 15px;

                    color: var(--green);

                    font-size: 11px;

                    font-weight: 900;

                    letter-spacing: 1.5px;
                }


                .purchase-divider {
                    height: 1px;

                    margin:
                        25px 0;

                    background:
                        rgba(255,255,255,.08);
                }


                .purchase-button {
                    justify-content: center;

                    color: #001014;

                    background:
                        var(--cyan);
                }


                .purchase-button:hover {
                    transform:
                        translateY(-2px);

                    box-shadow:
                        0 15px 35px
                        rgba(0,229,255,.2);
                }


                .secure-note {
                    display: flex;

                    justify-content: center;

                    gap: 7px;

                    margin-top: 18px;

                    color: #647286;

                    font-size: 11px;
                }


                .secure-note span {
                    color:
                        var(--green);
                }


                /* =====================================================
                   PAYMENT
                ===================================================== */

                .payment-page {
                    position: relative;

                    z-index: 2;

                    width: min(
                        1100px,
                        calc(100% - 40px)
                    );

                    margin: 0 auto;

                    padding-bottom: 80px;
                }


                .payment-wrapper {
                    padding:
                        25px;

                    border:
                        1px solid
                        rgba(255,255,255,.10);

                    border-radius: 22px;

                    background:
                        rgba(8,13,22,.92);
                }


                /* =====================================================
                   COUPON MODAL
                ===================================================== */

                .coupon-overlay {
                    position: fixed;

                    inset: 0;

                    z-index: 9999;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    padding: 20px;

                    background:
                        rgba(0,0,0,.78);

                    backdrop-filter:
                        blur(12px);
                }


                .coupon-modal {
                    position: relative;

                    width:
                        min(
                            520px,
                            100%
                        );

                    padding:
                        38px;

                    border:
                        1px solid
                        rgba(0,229,255,.25);

                    border-radius: 25px;

                    background:
                        linear-gradient(
                            145deg,
                            #101925,
                            #050a11
                        );

                    box-shadow:
                        0 40px 100px
                        rgba(0,0,0,.7),
                        0 0 40px
                        rgba(0,229,255,.08);
                }


                .coupon-close {
                    position: absolute;

                    top: 15px;
                    right: 15px;

                    width: 38px;
                    height: 38px;

                    border:
                        1px solid
                        rgba(255,255,255,.1);

                    border-radius: 50%;

                    background:
                        rgba(255,255,255,.04);

                    color: #8b98a8;

                    font-size: 25px;

                    cursor: pointer;
                }


                .coupon-icon {
                    width: 60px;
                    height: 60px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    margin-bottom: 20px;

                    border-radius: 18px;

                    background:
                        rgba(139,92,246,.12);

                    border:
                        1px solid
                        rgba(139,92,246,.35);

                    font-size: 28px;
                }


                .coupon-title span {
                    color: var(--purple);

                    font-size: 10px;

                    font-weight: 900;

                    letter-spacing: 2px;
                }


                .coupon-title h2 {
                    margin:
                        7px 0;

                    color: #ffffff;

                    font-size: 32px;
                }


                .coupon-title p {
                    margin:
                        0 0 25px;

                    color: #728096;

                    line-height: 1.6;
                }


                .coupon-input {
                    width: 100%;

                    height: 55px;

                    box-sizing: border-box;

                    margin-bottom: 20px;

                    padding:
                        0 17px;

                    outline: none;

                    border:
                        1px solid
                        rgba(255,255,255,.12);

                    border-radius: 13px;

                    background:
                        rgba(255,255,255,.04);

                    color: #ffffff;

                    font-size: 15px;
                }


                .coupon-input:focus {
                    border-color:
                        var(--cyan);

                    box-shadow:
                        0 0 20px
                        rgba(0,229,255,.08);
                }


                .coupon-applied-box {
                    margin-bottom: 20px;

                    padding: 17px;

                    border:
                        1px solid
                        rgba(34,197,94,.25);

                    border-radius: 13px;

                    background:
                        rgba(34,197,94,.08);

                    color: #a7e8b9;
                }


                .coupon-applied-box span {
                    margin-right: 8px;

                    color: var(--green);

                    font-weight: 900;
                }


                .coupon-actions {
                    display: grid;

                    grid-template-columns:
                        1fr 1fr;

                    gap: 12px;
                }


                .coupon-actions button {
                    min-height: 50px;

                    border-radius: 12px;

                    cursor: pointer;

                    font-weight: 850;
                }


                .coupon-apply {
                    border: none;

                    color: #001014;

                    background:
                        var(--cyan);
                }


                .coupon-remove {
                    border:
                        1px solid
                        rgba(239,68,68,.4);

                    color: #ff7777;

                    background:
                        rgba(239,68,68,.08);
                }


                .coupon-cancel {
                    border:
                        1px solid
                        rgba(255,255,255,.12);

                    color: #9aa8b8;

                    background:
                        transparent;
                }


                /* =====================================================
                   TABLET
                ===================================================== */

                @media (max-width: 1100px) {

                    .package-grid,
                    .course-grid {
                        grid-template-columns:
                            repeat(
                                2,
                                minmax(0,1fr)
                            );
                    }


                    .detail-layout {
                        grid-template-columns:
                            1fr;
                    }


                    .purchase-panel {
                        position: relative;

                        top: auto;
                    }

                }


                /* =====================================================
                   MOBILE
                ===================================================== */

                @media (max-width: 768px) {

                    .header-safe-space {
                        height: 105px;
                    }


                    .content-wrapper {
                        width:
                            calc(100% - 24px);
                    }


                    .store-hero {
                        display: block;

                        min-height: auto;

                        padding:
                            35px 24px;

                        margin-bottom: 25px;

                        border-radius:
                            0 0 20px 20px;
                    }


                    .store-hero h1 {
                        font-size:
                            clamp(
                                39px,
                                12vw,
                                58px
                            );

                        letter-spacing:
                            -2.5px;
                    }


                    .store-hero p {
                        font-size: 14px;

                        margin-top: 18px;
                    }


                    .hero-coupon {
                        width: 100%;

                        justify-content: center;

                        margin-top: 28px;
                    }


                    .view-switch-wrapper {
                        margin-bottom: 25px;
                    }


                    .view-switch {
                        width: 100%;
                    }


                    .switch-btn {
                        flex: 1;

                        min-width: 0;

                        padding:
                            14px 10px;

                        font-size: 12px;
                    }


                    .section-heading {
                        display: block;

                        margin-bottom: 20px;
                    }


                    .section-heading h2 {
                        font-size: 28px;
                    }


                    .section-heading p {
                        margin-top: 10px;

                        text-align: left;

                        font-size: 13px;
                    }


                    .package-grid,
                    .course-grid {
                        grid-template-columns: 1fr;

                        gap: 18px;
                    }


                    .product-image {
                        height:
                            clamp(
                                210px,
                                60vw,
                                270px
                            );
                    }


                    .product-body {
                        padding: 18px;
                    }


                    .product-body h3 {
                        min-height: auto;

                        font-size: 19px;
                    }


                    .course-description {
                        height: auto;

                        max-height: 66px;
                    }


                    .floating-cart {
                        right: 15px;

                        bottom: 15px;

                        width: 60px;
                        height: 60px;
                    }


                    .coupon-status {
                        align-items: flex-start;

                        flex-direction: column;
                    }


                    .coupon-status button {
                        width: 100%;

                        padding: 10px;

                        border:
                            1px solid
                            rgba(239,68,68,.25);

                        border-radius: 10px;
                    }


                    .detail-image {
                        height:
                            270px;

                        border-radius: 18px;
                    }


                    .detail-heading h1 {
                        font-size: 30px;
                    }


                    .detail-info {
                        padding: 15px;
                    }


                    .purchase-panel {
                        padding: 22px;

                        border-radius: 18px;
                    }


                    .purchase-price {
                        font-size: 38px;
                    }


                    .payment-page {
                        width:
                            calc(100% - 24px);
                    }


                    .payment-wrapper {
                        padding: 12px;
                    }


                    .coupon-overlay {
                        align-items: flex-end;

                        padding: 10px;
                    }


                    .coupon-modal {
                        width: 100%;

                        padding:
                            28px 20px;

                        border-radius:
                            22px 22px 15px 15px;
                    }


                    .coupon-title h2 {
                        font-size: 27px;
                    }


                    .coupon-actions {
                        grid-template-columns: 1fr;
                    }

                }


                /* =====================================================
                   SMALL MOBILE
                ===================================================== */

                @media (max-width: 420px) {

                    .header-safe-space {
                        height: 95px;
                    }


                    .content-wrapper {
                        width:
                            calc(100% - 18px);
                    }


                    .store-hero {
                        padding:
                            28px 18px;
                    }


                    .eyebrow {
                        font-size: 10px;

                        letter-spacing:
                            1.3px;
                    }


                    .store-hero h1 {
                        font-size: 40px;
                    }


                    .store-hero p {
                        font-size: 13px;
                    }


                    .switch-btn {
                        padding:
                            13px 5px;
                    }


                    .switch-btn span {
                        display: none;
                    }


                    .product-image {
                        height: 210px;
                    }


                    .product-body h3 {
                        font-size: 18px;
                    }


                    .current-price {
                        font-size: 25px;
                    }


                    .floating-cart {
                        width: 55px;
                        height: 55px;

                        right: 12px;
                        bottom: 12px;
                    }


                    .cart-label {
                        display: none;
                    }


                    .detail-image {
                        height: 220px;
                    }


                    .purchase-price {
                        font-size: 34px;
                    }

                }


                /* =====================================================
                   VERY SMALL SCREENS
                ===================================================== */

                @media (max-width: 340px) {

                    .store-hero h1 {
                        font-size: 35px;
                    }


                    .hero-coupon {
                        font-size: 11px;
                    }


                    .product-body {
                        padding: 15px;
                    }


                    .coupon-modal {
                        padding:
                            25px 16px;
                    }

                }


                /* =====================================================
                   ACCESSIBILITY
                ===================================================== */

                @media (prefers-reduced-motion: reduce) {

                    *,
                    *::before,
                    *::after {
                        animation-duration:
                            0.01ms !important;

                        animation-iteration-count:
                            1 !important;

                        scroll-behavior:
                            auto !important;

                        transition-duration:
                            0.01ms !important;
                    }

                }

            `}</style>
        </>
    );
};


export default Package;